import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { RequireAuth } from "./components/RequireAuth.js";
import { AppShell } from "./components/layout/AppShell.js";
import { GroupPage } from "./features/groups/GroupPage.js";
import { Groups } from "./features/groups/Groups.js";
import { Integrations } from "./features/integrations/Integrations.js";
import { Notifications } from "./features/notifications/Notifications.js";
import { Onboarding } from "./features/onboarding/Onboarding.js";
import { Orgs } from "./features/orgs/Orgs.js";
import { People } from "./features/people/People.js";
import { Sharing } from "./features/sharing/Sharing.js";
import { Tax } from "./features/tax/Tax.js";
import { Trips } from "./features/trips/Trips.js";
import { AuthProvider } from "./lib/auth-context.js";
import { ViewStateProvider } from "./lib/view-state.js";
import { EmailVerify } from "./pages/EmailVerify.js";
import { InviteLanding } from "./pages/InviteLanding.js";
import { Landing } from "./pages/Landing.js";
import { Login } from "./pages/Login.js";
import { CalendarPage, HoursPage, MapPage, ProfilePage } from "./pages/app-pages.js";

// Router pre-wires all top-level routes. The app shell hosts the four sections.
// M1 adds the auth route-guard around /app (anonymous → /login); M0 leaves the
// placeholders reachable so the shell is verifiable.
export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/i/:code" element={<InviteLanding />} />
          <Route path="/g/:slug" element={<GroupPage />} />
          <Route path="/auth/email" element={<EmailVerify />} />
          <Route element={<RequireAuth />}>
            <Route path="/onboarding" element={<Onboarding />} />
            <Route
              path="/app"
              element={
                <ViewStateProvider>
                  <AppShell />
                </ViewStateProvider>
              }
            >
              <Route index element={<MapPage />} />
              <Route path="people" element={<People />} />
              <Route path="trips" element={<Trips />} />
              <Route path="calendar" element={<CalendarPage />} />
              <Route path="hours" element={<HoursPage />} />
              <Route path="profile" element={<ProfilePage />} />
              <Route path="sharing" element={<Sharing />} />
              <Route path="notifications" element={<Notifications />} />
              <Route path="groups" element={<Groups />} />
              <Route path="orgs" element={<Orgs />} />
              <Route path="tax" element={<Tax />} />
              <Route path="integrations" element={<Integrations />} />
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
